export default {
	processedTasks: 'Některá z označených položek je již splněna/zpracována. Upravte svůj výběr.',
	userCanProcessMax10Tasks: 'Můžete předat/zpracovat najednou maximálně 10 úkolů/informací.',
	userDoesntHavePermissions:
		'Některou z označených položek nelze zpracovat, protože nejste jejím řešitelem. Upravte svůj výběr. ',
};
